"use client";

import React from 'react';

const points = [
  {
    title: "Dobór kamer do konkretnych zastosowań",
    desc: "Inne obiektywy do małych pomieszczeń i korytarzy, inne do parkingów, placów i dużych terenów zewnętrznych. Optymalny kąt widzenia dla każdego monitorowanego obszaru."
  },
  {
    title: "Prawdziwa noktowizja",
    desc: "Oferujemy rozwiązania zapewniające skuteczną obserwację nocną — zaawansowane systemy pracy w warunkach bardzo słabego oświetlenia, a nie tylko standardowe doświetlenie podczerwienią."
  },
  {
    title: "Kamery z zoomem optycznym",
    desc: "W miejscach wymagających obserwacji odległych obiektów stosujemy kamery z zoomem optycznym. Pozwala to przybliżać obraz bez utraty jakości."
  },
  {
    title: "Projektowanie zamiast przypadkowego montażu",
    desc: "Naszym celem nie jest sprzedaż jak największej liczby kamer, lecz stworzenie systemu, który będzie skutecznie spełniał swoje zadanie. Każda instalacja jest projektowana indywidualnie."
  }
];

export default function Differentiators() {
  return (
    <section className="section-band border-y py-20">
      <div className="max-w-screen-2xl mx-auto px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <div className="text-blue-500 font-semibold tracking-[2px] text-sm mb-2">CO NAS WYRÓŻNIA</div>
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tighter mb-4">
            Dlaczego nasz monitoring jest skuteczniejszy?
          </h2>
          <p className="text-lg text-zinc-400">
            Większość instalatorów montuje ten sam typ kamer niezależnie od miejsca. 
            My podchodzimy do każdego obiektu indywidualnie.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {points.map((point, index) => (
            <div key={index} className="dark-card rounded-3xl p-8">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 rounded-2xl bg-blue-600/20 text-blue-400 flex items-center justify-center flex-shrink-0 mt-1 font-bold">
                  {index + 1}
                </div>
                <div>
                  <h3 className="font-semibold text-xl mb-3">{point.title}</h3>
                  <p className="text-zinc-400 leading-relaxed">{point.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 text-sm text-zinc-400 max-w-md mx-auto">
          Dzięki temu monitoring nie tylko rejestruje obraz, ale pozwala rozpoznawać osoby, pojazdy i istotne szczegóły.
        </div>
      </div>
    </section>
  );
}
